import React from "react";
import { Div, Text, Input, Button, Row, Col } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import PrimaryButton from "./PrimaryButton";
import Swiper from "react-id-swiper";
import { Link } from "gatsby";
import AnimateLink from "./AnimateLink";

const params = {
  slidesPerView: "auto",
  spaceBetween: 10,
  mousewheel: {
    forceToAxis: true,
    invert: true,
  },
  slidesOffsetAfter: 40,
};

class CuratedNetwork extends React.Component {
  render() {
    const { content } = this.props;

    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div p={{ b: "2rem" }}>
            <Text
              textSize={{ xs: "caption4", md: "subheader3" }}
              style={{ lineHeight: "34px" }}
              textWeight="700"
              maxW="46.25rem"
              tag="h2"
            >
              {content.title ? content.title : ""}
            </Text>
          </Div>
          <Div d={{ xs: "none", lg: "block" }}>
            <Div>
              <Row>
                {content.cards.map((card, index) => {
                  return (
                    <Col size={4}>
                      <Div
                        bg={card.color}
                        p="1.6rem"
                        d="flex"
                        flexDir="column"
                        justify="space-between"
                        m={{ r: "0.5rem" }}
                        minH="23rem"
                      >
                        <Div>
                          <Div
                            textSize="subheader5"
                            style={{ lineHeight: "20px" }}
                            textWeight="700"
                          >
                            {card.heading}
                          </Div>
                          <Div style={{ lineHeight: "20px" }} m={{ t: "2rem" }}>
                            {card.text}
                          </Div>
                        </Div>
                        <Div m={{ t: "1rem" }}>
                          <AnimateLink to={`${card.link}`}>
                            <PrimaryButton
                              bg="white"
                              textColor="black"
                              textTransform="none"
                            >
                              <Text>{card.btnText}</Text>
                            </PrimaryButton>
                          </AnimateLink>
                        </Div>
                      </Div>
                    </Col>
                  );
                })}
              </Row>
            </Div>
          </Div>
        </CustomContainer>
        <Div d={{ xs: "block", lg: "none" }} className="solved-swiper">
          <Swiper {...params}>
            {content.cards.map((card, index) => {
              return (
                <Div key={index} maxW="18.75rem">
                  <Div
                    bg={card.color}
                    p="2rem"
                    d="flex"
                    flexDir="column"
                    justify="space-between"
                    m={{ r: "0.5rem" }}
                    minH="23rem"
                  >
                    <Div>
                      <Div
                        textSize="subheader5"
                        style={{ lineHeight: "20px" }}
                        textWeight="700"
                      >
                        {card.heading}
                      </Div>
                      <Div style={{ lineHeight: "20px" }} m={{ t: "2rem" }}>
                        {card.text}
                      </Div>
                    </Div>
                    <Div m={{ t: "1rem" }}>
                      <AnimateLink to={`${card.link}`}>
                        <PrimaryButton
                          bg="white"
                          textColor="black"
                          textTransform="none"
                        >
                          <Text>{card.btnText}</Text>
                        </PrimaryButton>
                      </AnimateLink>
                    </Div>
                  </Div>
                </Div>
              );
            })}
          </Swiper>
        </Div>
      </WebsiteContainer>
    );
  }
}

export default CuratedNetwork;
